export default __webpack_public_path__ + "static/media/loading_icons_gray_background.b0cb6b5c.gif";